module.exports = __webpack_public_path__ + "img/ic-white-ponde-comprar.634464f4.svg";